// API Types for UDA MCP Server

export interface HealthResponse {
  status: 'healthy' | 'unhealthy';
  timestamp: string;
  uptime: number;
  version: string;
  environment: string;
}

export interface StatusResponse {
  service: string;
  status: 'operational' | 'degraded' | 'down';
  version: string;
  endpoints: string[];
}

export interface MetricsResponse {
  timestamp: number;
  uptime: number;
  memory: {
    used: number;
    available: number;
  };
  requests: {
    total: number;
    errors: number;
    averageResponseTime: number;
  };
  models: {
    available: number;
    active: number;
  };
}

export interface ProjectInfo {
  path: string;
  name: string;
  language?: string;
  framework?: string;
}

export interface AnalysisResponse {
  projectInfo: ProjectInfo;
  ecosystems: any[];
  dependencies: any[];
  recommendations: any[];
}

export interface AnalysisRequest {
  path: string;
  language?: string;
  framework?: string;
}

export interface AIRoutingRequest {
  type: 'code-generation' | 'reasoning' | 'translation' | 'analysis' | 'optimization';
  complexity: 'low' | 'medium' | 'high';
  requirements?: {
    maxResponseTime?: number;
    maxCost?: number;
    minAccuracy?: number;
  };
}

export interface AIModel {
  name: string;
  provider: string;
  capabilities: string[];
  cost: number;
  performance: number;
}

export interface AIRoutingResponse {
  selectedModel: AIModel;
  confidence: number;
  reasoning: string;
  alternatives: AIModel[];
}

export interface SuggestionRequest {
  projectPath: string;
  packageName?: string;
  ecosystem?: string;
}

export interface Suggestion {
  name: string;
  version: string;
  ecosystem: string;
  description: string;
  compatibility: number;
  migrationComplexity: 'low' | 'medium' | 'high';
}

export interface SuggestionsResponse {
  suggestions: Suggestion[];
}

export interface APIError {
  error: string;
  code: string;
  details?: any;
}

export interface ApiResponse<T> {
  data?: T;
  error?: APIError;
  loading: boolean;
  status: number;
}

// Configuration
export const API_BASE_URL = 'https://api.fastpm.dev';
export const FRONTEND_URL = 'https://uda.fastpm.dev';

export const API_ENDPOINTS = {
  HEALTH: '/health',
  STATUS: '/',
  METRICS: '/metrics',
  ANALYZE: '/analyzeProject',
  AI_ROUTE: '/ai/route',
  SUGGESTIONS: '/suggest',
} as const;